export default "__VITE_ASSET__0695c3c9__"